export class Bisac {
  codice: string;
  descrizione: string;

  constructor(values: Object = {}) {
    Object.assign(this, values);
  }
}



// WEBPACK FOOTER //
// ./src/app/models/Bisac.ts